<template>
  <div class="step-header__wrapper">
    <div class="step-header__title">
      <slot name="title" />
    </div>

    <div
      class="step-header__close"
      @click="$emit('close')"
    >
      <gl-icon
        gray
        :height="24"
        name="I-S-Close"
        :width="24"
      />
    </div>
  </div>
</template>

<script>
// components
import GlIcon from '@/components/gl-icon'

export default {
  name: 'StepHeaderClose',
  components: {
    GlIcon,
  },
}
</script>

<style scoped>
.step-header__wrapper {
  display: flex;
  padding: 12px 12px 12px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 8px;
}

.step-header__title {
  text-align: left;
  font-size: var(--Size-L, 16px);
  font-weight: 700;
  line-height: var(--Line-Height-XL, 24px);
}

.step-header__close {
  cursor: pointer;
} 
</style>
